<div id="breadcrumb-container" class="breadcrumb-container text" (click)="goBack()">
  <div class="breadcrumb-left">
    <image-loader-utils url="up-arrow" extraClasses="arrow-icon left"></image-loader-utils>
  </div>
  <div class="breadcrumb-mid" *ngIf="this._DataHelper.selectedMatch">
    <div class="breadcrumb-tournament-name">
      <ng-container *ngIf="this._DataHelper.selectedMatch?.TournamentName === ('MyBets' | translate); else flag">
        <div class="breadcrumb-turnament-icon">
          <image-loader-utils url="my-bets" extraClasses="svg"></image-loader-utils>
        </div>
      </ng-container>

      <ng-template #flag>
        <div class="breadcrumb-turnament-icon">
          <image-loader-flag-utils [url]="this._DataHelper.selectedMatch?.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-flag-utils>
        </div>
      </ng-template>

      <strong class="template-name">
        {{ this._DataHelper.selectedMatch?.TournamentName }}
      </strong>
    </div>
  </div>

  <div class="breadcrumb-mid" *ngIf="!this._DataHelper.selectedMatch">
    <div class="breadcrumb-turnament-icon">
      <image-loader-utils url="sports" extraClasses="svg"></image-loader-utils>
    </div>
    <div class="breadcrumb-tournament-noname">
      <strong> {{ 'SPORTS' | translate }} </strong>
    </div>
  </div>

  <div class="breadcrumb-right">
    <div class="star-icon"></div>
  </div>
</div>

<div class="p1001-scoreboard-container text" *ngIf="showScoreBoard">
  <ng-container *ngIf="this._UserHelper.isSignedIn">
    <div class="box first" (click)="addMatch2Favs()">
      <image-loader-utils
        [extraClasses]="'star-icon ' + (this._DataHelper.favList.includes(eventid * 1) ? 'star-icon-active' : 'star-icon-disabled')"
        url="star"></image-loader-utils>
    </div>
  </ng-container>
  <div class="box second">
    <!-- <image-loader-utils *ngIf="this._UserHelper.isSignedIn" url="like" [extraClasses]="'like-icon ' + (this.event.HomeTeamChecked ? 'myTeamChecked' : '')"></image-loader-utils> -->
    <ng-container *ngIf="'isMyTeam' | getEnv">
      <div class="like-button" *ngIf="this._UserHelper.isSignedIn" (click)="addCustomerTeamList(this.event.HomeTeamId)">
        <div class="heart-bg">
          <div class="heart-icon liked" [ngClass]="{ liked: this.event?.HomeTeamChecked || isFirstFlag }"></div>
        </div>
      </div>
    </ng-container>

    {{ this.event?.HomeTeam }}
  </div>
  <div class="box third">
    <div class="date">
      {{ this.event?.EventFullDate | dateFormat : 'dd-MM' }}
    </div>
    <div class="time">
      {{ this.event?.EventFullDate | dateFormat : 'HH:mm' }}
    </div>
  </div>
  <div class="box fourth">
    {{ this.event?.AwayTeam }}
    <ng-container *ngIf="'isMyTeam' | getEnv">
      <div class="like-button" *ngIf="this._UserHelper.isSignedIn" (click)="addCustomerTeamList(this.event.AwayTeamId)">
        <div class="heart-bg">
          <div class="heart-icon" [ngClass]="{ liked: this.event?.AwayTeamChecked || isFirstFlag }"></div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="box fifth" (click)="openHeadToHeadDialog()">
    <image-loader-utils [url]="iconUrl" extraClasses="signal-icon" (click)="onIconClick()"></image-loader-utils>
  </div>
</div>

<div class="widgets">
  <div class="sr-widget sr-widget-2"></div>
</div>

<div class="event-detail-tab">
  <div class="event-detail-tab-item">
    <div class="right">
      <div id="search">
        <input
          [(ngModel)]="searchValue"
          (input)="searchOdd(search.value)"
          #search
          type="search"
          [placeholder]="filled ? ('Search' | translate) : ''"
          [ngClass]="{ filled: filled }"
          (click)="openSearchBar()"
          (blur)="filled = search.value ? true : false" />
      </div>
    </div>
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 2 }" (click)="eventDetailTabItemChange(2)">
    {{ 'OddsAll' | translate }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 1 }" (click)="eventDetailTabItemChange(1)">
    {{ 'OddsPopular' | translate }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 3 }" (click)="eventDetailTabItemChange(3)">
    {{ 'OddsMatchResult' | translate }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 7 }" (click)="eventDetailTabItemChange(7)">
    {{ 'OddsOverUnder' | translate }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 4 }" (click)="eventDetailTabItemChange(4)">
    {{ 'OddsFirstHalf' | translate }}
  </div>
  <div class="event-detail-tab-item" [ngClass]="{ active: eventDetailTabItemSelected == 6 }" (click)="eventDetailTabItemChange(6)">
    {{ 'OddsAsia' | translate }}
  </div>
</div>
<div class="event-detail-tab-content" id="event-detail-tab-content">
  <ng-container *ngFor="let oddType of this.eventdetailList | groupOddsByName | sortBy : false : 'seq'; let i = index">
    <div class="event-detail-odd-box" [ngClass]="{ 'active-event-detail-box': isOddSelected(oddType) }">
      <div class="event-detail-odd-title">
        {{ oddType.GroupName.split('|')[1] }}
        <ng-container *ngIf="'isOddFav' | getEnv">
          <div class="fav-odd" (click)="addOdd2Favs(oddType.OddTypeId)">
            <image-loader-utils url="star" [extraClasses]="'star-icon ' + (isOddFavorite(oddType.OddTypeId) ? 'matchfavourited' : '')"></image-loader-utils>
          </div>
        </ng-container>
      </div>
      <div class="event-detail-odd-content">
        <ng-container *ngFor="let odd of oddType.eOdds | sortBy : true : 'SeqNumber' : sortedBy">
          <div
            class="event-detail-odd-button"
            (click)="clickOdd(odd)"
            [ngClass]="{
              active: checkOddId(odd.OddId) === 'active',
              'btn-single': oddType.eOdds.length == 1,
              'btn-double': oddType.eOdds.length == 2,
              'btn-triple': oddType.eOdds.length == 3,
              'btn-multiple': oddType.eOdds.length > 3
            }">
            <div class="event-detail-odd-outcome">{{ odd.OutComeOrginal }}</div>
            <div class="event-detail-odd-value">
              {{ odd.OddValue | oddFormat }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <div *ngIf="this.eventdetailList == undefined || this.eventdetailList.length < 1" class="event-detail-skeleton">
    <ngx-skeleton-loader [theme]="{ height: '30px', width: '90%', background: 'var(--white-color-300)' }" count="10"></ngx-skeleton-loader>
  </div>
  <div class="top-button-container event-detail" (click)="ScrollToTop()">
    <div class="top-button">
      <div class="text-name">
        {{ 'back_to_top' | translate }}
      </div>
      <div class="right">
        <image-loader-utils url="up-arrow" extraClasses="arrow-icon up"></image-loader-utils>
      </div>
    </div>
  </div>
</div>
